import { useEffect } from 'react'
import './AlertModal.css'

interface AlertModalProps {
  isOpen: boolean
  message: string
  title?: string
  onClose: () => void
  type?: 'info' | 'warning' | 'error' | 'success'
}

export function AlertModal({ isOpen, message, title, onClose, type = 'info' }: AlertModalProps) {
  useEffect(() => {
    if (isOpen) {
      const handleEscape = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          onClose()
        }
      }
      document.addEventListener('keydown', handleEscape)
      return () => document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const getTypeIcon = () => {
    switch (type) {
      case 'error':
        return '❌'
      case 'warning':
        return '⚠️'
      case 'success':
        return '✅'
      default:
        return 'ℹ️'
    }
  }

  const getTypeClass = () => {
    switch (type) {
      case 'error':
        return 'alert-error'
      case 'warning':
        return 'alert-warning'
      case 'success':
        return 'alert-success'
      default:
        return 'alert-info'
    }
  }

  return (
    <div className="alert-modal-overlay" onClick={onClose}>
      <div className={`alert-modal-content ${getTypeClass()}`} onClick={(e) => e.stopPropagation()}>
        <div className="alert-modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span style={{ fontSize: '1.5rem' }}>{getTypeIcon()}</span>
            <h2>{title || (type === 'error' ? 'Chyba' : type === 'warning' ? 'Varování' : type === 'success' ? 'Úspěch' : 'Informace')}</h2>
          </div>
          <button className="alert-modal-close" onClick={onClose} title="Zavřít">
            ×
          </button>
        </div>
        <div className="alert-modal-body">
          <p style={{ margin: 0, whiteSpace: 'pre-line' }}>{message}</p>
        </div>
        <div className="alert-modal-footer">
          <button className="alert-modal-button" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  )
}

export default AlertModal


